import { render, staticRenderFns } from "./CareLevels.vue?vue&type=template&id=11453a7a&scoped=true"
import script from "./CareLevels.ts?vue&type=script&lang=ts&external"
export * from "./CareLevels.ts?vue&type=script&lang=ts&external"
import style0 from "./CareLevels.scss?vue&type=style&index=0&id=11453a7a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11453a7a",
  null
  
)

export default component.exports